export const navLinks = [
  { id: 'entrance', label: '三大入口' },
  { id: 'hot', label: '热度榜单' },
  { id: 'feed', label: '吃瓜速递' },
  { id: 'feature', label: '高能专题' },
  { id: 'help', label: '找不到入口?' },
];

export const entrances = [
  {
    icon: 'ri-shield-star-line',
    key: '官网入口',
    name: '官网入口',
    desc: '吃瓜网站主站直达通道，浏览器打开即进首页，随时随地刷新爆料与动态。',
    status: '正常访问',
    tone: 'primary',
    action: '进入官网',
  },
  {
    icon: 'ri-flashlight-line',
    key: '最新地址',
    name: '最新地址',
    desc: '官网若更换域名，这里第一时间同步最新地址，一键直达不走弯路。',
    status: '实时同步',
    tone: 'accent',
    action: '查看最新地址',
  },
  {
    icon: 'ri-lifebuoy-line',
    key: '备用入口',
    name: '备用入口',
    desc: '遇到打不开或暂时拥挤时，切换到备用入口继续浏览，吃瓜不断线。',
    status: '畅通可用',
    tone: 'secondary',
    action: '切换备用入口',
  },
];

export const hotItems = [
  { rank: 1, title: '本周话题热度延续，观众持续在线围观最新动态', tag: '热度飙升', score: '98.6' },
  { rank: 2, title: '现场生图刷屏社交圈，评论区讨论量节节攀升', tag: '讨论暴涨', score: '94.1' },
  { rank: 3, title: '一段现场视频冲上趋势前列，转发已破百万', tag: '火爆全场', score: '89.3' },
  { rank: 4, title: '新一期内容上线即获好评，口碑稳步走高', tag: '好评如潮', score: '82.7' },
  { rank: 5, title: '网友自发复盘经典片段，二次创作持续产出', tag: '持续发酵', score: '76.9' },
  { rank: 6, title: '跨平台话题同框联动，热度相互助推再上一层', tag: '联动走热', score: '71.2' },
];

export const feedCards = [
  {
    img: 'https://readdy.ai/api/search-image?query=Editorial%20still%20life%20photography%20of%20juicy%20fresh%20watermelon%20slices%20and%20melons%20on%20warm%20cream%20background%2C%20soft%20natural%20window%20light%2C%20minimal%20summer%20magazine%20aesthetic%2C%20gentle%20shadows%2C%20clean%20airy%20composition%2C%20high%20detail%2C%20warm%20and%20appetizing%20mood&width=880&height=580&seq=feed-01&orientation=landscape',
    tag: '生活百科',
    title: '夏天吃瓜的正确打开方式，一文讲清常见误区',
    desc: '从挑选到保存再到食用，把吃瓜这件小事讲得明明白白。',
    meta: '小编整理 · 5分钟前',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Backstage%20of%20a%20concert%20stage%20with%20warm%20golden%20spotlights%20and%20silhouetted%20crew%2C%20editorial%20entertainment%20photography%2C%20dramatic%20warm%20lighting%2C%20film%20grain%2C%20cinematic%20backstage%20vibe%2C%20high%20detail%2C%20no%20real%20person%20faces&width=880&height=580&seq=feed-02&orientation=landscape',
    tag: '现场直击',
    title: '深夜现场直击：散场后粉丝仍在场外久久不散',
    desc: '热度背后的真实瞬间，跟镜头一起走进这场久违的沸腾。',
    meta: '现场组 · 18分钟前',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20smartphone%20showing%20glowing%20colorful%20notification%20icons%20on%20a%20warm%20desk%20at%20night%2C%20bokeh%20city%20lights%20background%2C%20editorial%20tech%20culture%20photography%2C%20vibrant%20yet%20warm%20tone%2C%20modern%20social%20vibe%2C%20high%20detail%2C%20abstract%20screen%20no%20readable%20text&width=880&height=580&seq=feed-03&orientation=landscape',
    tag: '网络热梗',
    title: '这句话突然刷屏，到底从哪儿火起来的?',
    desc: '一个梗的走红路径拆解，看看它为何能精准戳中无数人。',
    meta: '梗百科 · 1小时前',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Editorial%20photography%20of%20popcorn%2C%20movie%20tickets%20and%20warm%20cinema%20seat%20lights%20in%20a%20cozy%20theater%2C%20soft%20amber%20glow%2C%20film%20night%20vibe%2C%20minimal%20composition%2C%20warm%20color%20palette%2C%20high%20detail%2C%20no%20text&width=880&height=580&seq=feed-04&orientation=landscape',
    tag: '影视闲聊',
    title: '近期高口碑片单盘点，这几部值得二刷三刷',
    desc: '把评分与口碑掰开揉碎，帮你把观影清单提前备好。',
    meta: '片单控 · 2小时前',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Press%20conference%20table%20with%20microphones%20and%20notepads%20under%20warm%20stage%20lighting%2C%20editorial%20journalism%20photography%2C%20blurred%20background%2C%20no%20people%2C%20warm%20golden%20tones%2C%20candid%20newsroom%20atmosphere%2C%20high%20detail%2C%20clean%20composition&width=880&height=580&seq=feed-05&orientation=landscape',
    tag: '新鲜出炉',
    title: '发布会刚结束，这些关键信息值得划重点',
    desc: '把发布会里的干货一网打尽，重点信息帮你一次看透。',
    meta: '情报站 · 3小时前',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Summer%20picnic%20flat%20lay%20on%20warm%20checkered%20cloth%20with%20fresh%20fruits%2C%20melon%20and%20lemonade%2C%20sunlit%20green%20garden%20background%2C%20editorial%20lifestyle%20magazine%20photography%2C%20bright%20warm%20sunlight%2C%20cheerful%20relaxed%20mood%2C%20high%20detail&width=880&height=580&seq=feed-06&orientation=landscape',
    tag: '周末漫谈',
    title: '周末放空计划：慢下来，把快乐找回来',
    desc: '不赶时间的下午，用一点小事把紧绷的日子重新温热。',
    meta: '生活家 · 5小时前',
  },
];

export const featurePost = {
  img: 'https://readdy.ai/api/search-image?query=Wide%20editorial%20photography%20of%20a%20lush%20green%20watermelon%20field%20at%20golden%20hour%20with%20warm%20sunlight%2C%20ripe%20melons%20on%20the%20vines%2C%20soft%20dreamy%20glow%2C%20cinematic%20magazine%20feature%20shot%2C%20summer%20harvest%20mood%2C%20warm%20golden%20and%20green%20palette%2C%20high%20detail%2C%20breathtaking%20vista&width=1400&height=880&seq=feature-01&orientation=landscape',
  tag: '高能专题 · 深度',
  title: '热度是怎么一点一点滚起来的',
  subtitle: '我们追踪了一场话题从零到全网沸腾的完整路径，试着读懂每一次刷屏背后的节奏与逻辑。',
  points: [
    '源头：一条帖子的初始涟漪',
    '扩散：小圈层如何破圈发酵',
    '高峰：多平台同步引爆',
    '回响：热度退去后留下什么',
  ],
};

export const helpSteps = [
  { icon: 'ri-link-m', step: '第一步', title: '认准本站入口', desc: '把本站加入收藏夹，官网入口、最新地址与备用入口都在这里。' },
  { icon: 'ri-refresh-line', step: '第二步', title: '地址更新看这里', desc: '官网更换域名时，最新地址会第一时间同步，跟随指引即可直达。' },
  { icon: 'ri-route-line', step: '第三步', title: '备用入口兜底', desc: '遇到打不开或访问拥挤，一键切到备用入口，浏览体验不受影响。' },
];